import { useSpring, animated } from "@react-spring/web";
import { useMemo } from "react";

export const useSpringReveal = height => {
  const opacity = height > 1 ? 1 : 0;
  const addressSpring = useSpring({height, opacity});
  return addressSpring;
};

export const useAnimatedWrapper = element => {
  return useMemo(() => animated(element), [element]);
};
